<template>

  <div class="modal fade" id="AddCategorieActiviteModal" tabindex="-1" role="dialog" ref="addCategorieActiviteModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="CategorieActivite">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title">{{ title }}</h4>
                      <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <Form ref="categorieActiviteForm" @submit="AddCategorieActivite" :validation-schema="categorieActiviteSchema">
                      <div class="row">
                        
                        <div class="col-md-12 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Libelle <span class="text-danger">*</span>
                            </label>
                            <Field name="libelle" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                            <ErrorMessage name="libelle" class="text-danger"/>
                          </div>     
                        </div>
                    
                        <button
                          class="btn btn-primary"
                          type="submit">
                          {{ btntext }}
                        </button>
                      </div>
                    </Form>
                  </div>
               
              </div>
          </div>
      </div>
  </template> 
  
  <script lang="ts">
  import { ref, watch } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, hideModal, success } from '@/utils/utils';
  import { CategorieActivite } from '@/models/CategorieActivite';
  import { useRouter } from 'vue-router';
  import AddCategorieActivitePage from '@/pages/CategorieActivite/AddCategorieActivitePage.vue';
  
  export default {
    name: "AddCategorieActiviteModal",
    components: {
      Form,
      Field,
      ErrorMessage
    },
    props:{
      id: {
        type: Number,
        required: true,
        default:0
      },
    },
    emits: ["refreshCategorieActivites",'openmodal'],
  
    setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {

      const loading = ref<boolean>(false);
      const categorieActiviteSchema = Yup.object().shape({
        libelle: Yup.string().required('Le libelle est obligatoire'),

      });
  
  
      const categorieActivitenew = ref(props.id);
      const categorieActiviteForm =  ref<CategorieActivite | null>(null);
      const addCategorieActiviteModalRef = ref<null | HTMLElement>(null);
      let categorieActivites= ref<Array<CategorieActivite>>([]);
      const title = ref('Ajouter une categorie activité ');
      const btntext = ref('Ajouter');
      const isupdate=ref(false);
      const router = useRouter();
  
      watch(() => props.id , (newValue) => {   
        if (newValue!=0) {
          getCategorieActivite(newValue);
          isupdate.value=true;
        }
        btnTitle();
      });
  
      const getCategorieActivite = async (id: number) => {
        return ApiService.get("/categorieActivites/"+id)
        .then(({ data }) => {
          categorieActiviteForm.value?.setFieldValue("id",data.data.id);
          categorieActiviteForm.value?.setFieldValue("libelle",data.data.libelle);
          emit('openmodal', addCategorieActiviteModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }
  
      const btnTitle = async () => {
        if (isupdate.value) {
           title.value = "Modifier la catégorie";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter une catégorie";
           btntext.value = "Ajouter";
        }
      }
  
      const AddCategorieActivite = async (values:any, {resetForm}: {resetForm: () => void  }) => {
        values = values as CategorieActivite;
        loading.value = false;
        if(isupdate.value) {
          ApiService.put(`/categorieActivites/${values.id}`,values)
          .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              resetForm();
              hideModal(addCategorieActiviteModalRef.value);
              isupdate.value=false;
              btnTitle();
              emit("refreshCategorieActivites");
              router.push('/liste-categorie-activite');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }else{
          ApiService.post("/categorieActivites",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message)
              resetForm();
              hideModal(addCategorieActiviteModalRef.value);
              emit("refreshCategorieActivites");
  
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }
      }; 
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isupdate.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return {categorieActivites, title,btntext, resetValue, categorieActiviteSchema,
         AddCategorieActivite, categorieActiviteForm,addCategorieActiviteModalRef,categorieActivitenew,
         //refreshReligions
         };
    },
  };
  </script>@/models/CategorieActivite